<template>
  <div class="section3-container">
    <div class="box">
      <swiper :options="swiperOption">
        <swiper-slide>
          <div class="product-box product1">
            <div class="product-wrapper row m-0">
              <div class="product-item col-12 col-md">
                <div class="product-circle item">
                  <img src="@images/circle.png" />
                </div>
                <div class="product-package item">
                  <img src="@images/product/02.png" />
                </div>
              </div>
              <div class="product-text col-12 col-md">
                <div class="text-item">
                  <h2>{{ $t("message.section3.title[0]") }}</h2>
                  <h3>{{ $t("message.section3.sub[0]") }}</h3>
                  <router-link :to="{ name: 'Product' }">
                    <button>{{ $t("message.section3.button") }}</button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="product-box product2">
            <div class="product-wrapper row m-0">
              <div class="product-item col-12 col-md">
                <div class="product-circle item">
                  <img src="@images/circle.png" />
                </div>
                <div class="product-package item">
                  <img src="@images/product/01.png" />
                </div>
              </div>
              <div class="product-text col-12 col-md">
                <div class="text-item">
                  <h2>{{ $t("message.section3.title[1]") }}</h2>
                  <h3>{{ $t("message.section3.sub[1]") }}</h3>
                  <router-link :to="{ name: 'Product' }">
                    <button>{{ $t("message.section3.button") }}</button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="product-box product3">
            <div class="product-wrapper row m-0">
              <div class="product-item col-12 col-md">
                <div class="product-circle item">
                  <img src="@images/circle.png" />
                </div>
                <div class="product-package item">
                  <img src="@images/product/03.png" />
                </div>
              </div>
              <div class="product-text col-12 col-md">
                <div class="text-item">
                  <h2>{{ $t("message.section3.title[2]") }}</h2>
                  <h3>{{ $t("message.section3.sub[2]") }}</h3>
                  <router-link :to="{ name: 'Product' }">
                    <button>{{ $t("message.section3.button") }}</button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="product-box product4">
            <div class="product-wrapper row m-0">
              <div class="product-item col-12 col-md">
                <div class="product-circle item">
                  <img src="@images/circle.png" />
                </div>
                <div class="product-package item">
                  <img src="@images/product/04.png" />
                </div>
              </div>
              <div class="product-text col-12 col-md">
                <div class="text-item">
                  <h2>{{ $t("message.section3.title[3]") }}</h2>
                  <h3>{{ $t("message.section3.sub[3]") }}</h3>
                  <router-link :to="{ name: 'Product' }">
                    <button>{{ $t("message.section3.button") }}</button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <div
          class="swiper-button-prev swiper-button-white ml-3"
          slot="button-prev"
        ></div>
        <div
          class="swiper-button-next swiper-button-white mr-3"
          slot="button-next"
        ></div>
      </swiper>
      <div class="separator">
        <img src="@images/border-black.png" />
      </div>
      <div class="separator white">
        <img src="@images/border-white.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "section3",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        dragable: false,
        autoplay: {
          delay: 5000
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        loop: true
      }
      // swiperSlides: [1, 2, 3, 4, 5]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@scss/home/section3.scss";
</style>